<template>
  <div v-loading="loading" class="new-question-show flex-1 overflow-auto">
    <render-container-group>
      <render-container v-for="qs of questionList" :key="qs.q_id">
        <preview-question  :question="qs" :enableQuestionIndex="enableQuestionIndex"/>
        <div v-if="qs.confirmText || (qs.confirmFiles && qs.confirmFiles.length)" class="confirm-info">
          <div class="confirm-info__header">
            <span>答案变更佐证</span>
          </div>
          <div v-if="qs.confirmText" class="confirm-info__text">{{ qs.confirmText }}</div>
          <div v-if="qs.confirmFiles && qs.confirmFiles.length" class="confirm-info__files">
            <a
              v-for="(file, idx) in qs.confirmFiles"
              :key="idx"
              :href="convertDownloadUrl(file.url)"
              target="_blank"
              class="confirm-info__file"
            >{{ file.name }}</a>
          </div>
        </div>
      </render-container>
    </render-container-group>
  </div>
</template>

<script>
import pc from 'pc'
import { createQuestionFactory } from '@dygc/question'
import { detail } from '@/api/wenjuan/answerList'
const PreviewQuestion = pc.PreviewQuestion
import { convertAnswerText } from '@/question/convert.js'
import { getQuestionNo, getColsestDif, isPreNo } from '@/components/survey-detail/detailMeans'
import RenderContainerGroup from '@/components/base/RenderContainerGroup.vue'
import RenderContainer from '@/components/base/RenderContainer.vue'
import { convertDownloadUrl } from '@/api/file'

export default {
  name: 'NewQuestionShow',
  components: {
    RenderContainer, RenderContainerGroup,
    PreviewQuestion // 答卷详情预览
  },
  props: {
    answerId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      feikaiArr: [],
      questionList: [],
      loading: false
    }
  },
  computed:{
    enableQuestionIndex(){
      return this.$store.getters.otherSetting?.enableQuestionIndex !== false
    }
  },
  watch: {
    answerId(n) {
      if (n) this.getDetail(n)
    }
  },
  methods: {
    getQuestionNo,
    getColsestDif,
    isPreNo,
    convertDownloadUrl,
    getDetail(aswId) {
      this.loading = true
      detail(aswId).then(res => {
        const d = res.data.data
        this.feikaiArr = d.answerContent
        this.feikaiArr.length && this.getQuestionNo()
        this.questionList = this.feikaiArr.filter(item=>item.questionDetails).map((item) => {
          item.questionDetails = {
            ...item.questionDetails,
            content: {
              ...item.questionDetails.content,
              text: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent),
              richText: convertAnswerText(item.questionDetails.content.richText || item.questionDetails.content.text, d.answerContent)
            }
          }
          const q = createQuestionFactory(item.questionDetails)
          q.confirmText = item.confirmText
          q.confirmFiles = item.confirmFiles
          q.changeAnswerShowWarning = this.$store.getters.otherSetting?.changeAnswerShowWarning === true
          q.oldValue = item.oldItems?{...item,items:item.oldItems}:item
          q.setValue(item)
          q.disabledProgress = true
          q.num = item.questionNo
          return q
        })
        this.loading = false
      })
    }
  },
  created() {
    this.getDetail(this.answerId)
  }
}
</script>

<style>
.confirm-info {
  margin: 8px 16px 0;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 13px;
  color: #606266;
}
.confirm-info__header {
  font-weight: 500;
  margin-bottom: 6px;
  color: #303133;
}
.confirm-info__text {
  white-space: pre-wrap;
  line-height: 1.5;
}
.confirm-info__files {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.confirm-info__file {
  color: #409eff;
  text-decoration: none;
}
.confirm-info__file:hover {
  text-decoration: underline;
}
</style>
